// extracted by mini-css-extract-plugin
module.exports = {"hiring":"hiring_hiring__xSy5x","pagination-layout":"hiring_pagination-layout__E4AmG","pagination":"hiring_pagination__Xr3pp"};